import { createSlice } from "@reduxjs/toolkit";

const homeSlice = createSlice({
  name: "home",
  initialState: {
    homeData: {
      newNews: [],
      tourHotData: [],
      tourNewData: [],
      favoriteData: [],
    },
    loading: false,
    error: false,
  },
  reducers: {
    getHomeData: (state) => {
      state.loading = true;
      state.error = false;
    },
    getHomeDataSuccess: (state, action) => {
      state.loading = false;
      state.homeData = action.payload.data
      state.error = false;
    },
    getHomeDataFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const homeActions = homeSlice.actions;
export default homeSlice.reducer;
